module.exports = __webpack_public_path__ + "img/product_19.817d5bc.jpg";